import React from "react";

const NotFound = () => {
  return (
    <div>
      <h1>Page Not Found</h1>
      <br />
      <h2>Please try again...</h2>
      <br />
      <p className="lead">The page you are looking for has not been found.</p>
    </div>
  );
};

export default NotFound;
